module.exports = __webpack_public_path__ + "img/webchat.297ff4e4.png";